import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef
} from 'primeng/dynamicdialog';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  standalone: true,
  selector: 'app-view-notification',
  templateUrl: './notification-information.dialog.html',
  imports: [CommonModule, ButtonModule, SharedModule, ChipModule],
  providers: [DialogService]
})
export class NotificationInformationDialogComponent implements OnInit {
  message!: string;
  data!: any;
  moduleData!: any;
  moduleType!: string;

  constructor(
    public dialogService: DialogService,
    public messageService: MessageService,
    public ref: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    this.data = this.config.data;
    this.message = this.data.message;
    this.moduleType = this.data.moduleType;
    this.moduleData = this.data.relatedItemID;
  }

  ngOnInit(): void {}

  public confirmationResponse(confirm: boolean) {
    this.ref.close(confirm);
  }
}
